import styled, { css } from 'styled-components';

export const StatisticsWrapper = styled.div`
    display: grid;
    gap: 24px;
    grid-template-columns: repeat(3, 1fr);
`;

export const OrnamentWrapper = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
`;

export const StatisticWithLabel = styled.div<{ hasLabel?: boolean }>(
    ({ hasLabel, theme: { palette, radius } }) => css`
        align-items: center;
        display: flex;
        flex-direction: column;

        ${hasLabel &&
        css`
            p:first-of-type {
                position: relative;

                &::before {
                    background-color: ${palette.tertiary.default};
                    border-radius: ${radius[50]}%;
                    content: '';
                    height: 4px;
                    position: absolute;
                    top: 6px;
                    left: -8px;
                    width: 4px;
                }
            }
        `}
    `,
);
